<ngx-spinner [name]="'consultar-grupos'" type="ball-clip-rotate-pulse" [fullScreen]="false"
    bdColor="rgba(0, 0, 0, 0.2)"></ngx-spinner>
<!-- <mat-card style=" width: fit-content;"> -->
<mat-card>
    <mat-card-header>
        <mat-card-title>Consultar Grupos</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>
    <mat-card-content>

        <div class="row">
            <div class="col-auto">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Filtro</mat-label>
                    <input id="inputFiltro"  [(ngModel)]="filtroTabela" matInput (keyup)="aplicarFiltroTabela($event)" placeholder="Filtro"
                        autofocus>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-auto">
                <table mat-table [dataSource]="gruposSource" class="mat-elevation-z2" style="width: 100%;">

                    <!-- Nome -->
                    <ng-container matColumnDef="Nome">
                        <th mat-header-cell *matHeaderCellDef> Nome </th>
                        <td mat-cell *matCellDef="let element">
                            <div *ngIf="!element.Input">
                                {{element.Nome}}
                            </div>
                            <mat-form-field style="height: 50px; margin-top: -20px; margin-left: -10px;"
                                floatLabel="never" *ngIf="element.Input">
                                <input [id]="element.ID" matInput placeholder="Nome do grupo" [value]="element.Nome"
                                    [(ngModel)]="element.Nome" maxlength="50">
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <!-- Editar -->
                    <ng-container matColumnDef="Consultar">
                        <th mat-header-cell *matHeaderCellDef> Alterar </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button matTooltip="Detalhar grupo" (click)="editarGrupo(element)"
                                class="iconbutton" *ngIf="!element.Input" color="primary">
                                <mat-icon aria-label="Editar">edit</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <!-- No data MSG. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="2" style="text-align: center;">Não há grupos cadastrados no sistema ou com o filtro definido
                        </td>
                    </tr>
                </table>

                <mat-paginator [pageSizeOptions]="[10, 15, 20, 25]"></mat-paginator>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-sm text-right" *ngIf="bBtSalvar">
                <button mat-flat-button color="primary" (click)="atualizar()">
                    <mat-icon>check</mat-icon> Atualizar Dados
                </button>
            </div>
        </div>
    </mat-card-content>
</mat-card>
